import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
	MatSnackBarModule,
	MAT_SNACK_BAR_DEFAULT_OPTIONS,
} from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';

import { NgChartsModule } from 'ng2-charts';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { PermissionDeniedDialogComponent } from '../modules/general/permission-denied/permission-denied-dialog.component';

import { ChartComponent } from './components/chart/chart.component';
import { ChipComponent } from './components/chip/chip.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { FilesDialogComponent } from './components/dialogs/files-dialog.component';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { ModalComponent } from './components/modal/modal.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SnackBarComponent } from './components/snack-bar/snack-bar.component';
import { TabComponent } from './components/tab/tab.component';
import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { CapitalizeMonthPipe } from './pipes/capitalize-month.pipe';
import { SkeletonComponent } from './skeleton/skeleton.component';

const MaterialModules = [
	A11yModule,
	MatBadgeModule,
	MatButtonModule,
	MatButtonToggleModule,
	MatCheckboxModule,
	MatDatepickerModule,
	MatDialogModule,
	MatExpansionModule,
	MatIconModule,
	MatInputModule,
	MatMenuModule,
	MatNativeDateModule,
	MatRippleModule,
	MatPaginator,
	MatProgressBarModule,
	MatProgressSpinnerModule,
	MatRadioModule,
	MatSelectModule,
	MatSidenavModule,
	MatSlideToggleModule,
	MatSnackBarModule,
	MatButtonToggleModule,
	MatCheckboxModule,
	MatTabsModule,
	MatTableModule,
	ReactiveFormsModule,
];

@NgModule({
	declarations: [
		CapitalizeMonthPipe,
		ChartComponent,
		ChipComponent,
		DialogComponent,
		ErrorDialogComponent,
		FilesDialogComponent,
		HeaderComponent,
		MenuComponent,
		ModalComponent,
		PaginationComponent,
		PermissionDeniedDialogComponent,
		SkeletonComponent,
		SnackBarComponent,
		TabComponent,
	],
	exports: [
		CapitalizeMonthPipe,
		ChartComponent,
		ChipComponent,
		DialogComponent,
		ErrorDialogComponent,
		FilesDialogComponent,
		FormsModule,
		HeaderComponent,
		MenuComponent,
		ModalComponent,
		NgChartsModule,
		NgxMaskDirective,
		NgxMaskPipe,
		NgxSkeletonLoaderModule,
		PaginationComponent,
		PermissionDeniedDialogComponent,
		ReactiveFormsModule,
		RouterModule,
		SkeletonComponent,
		SnackBarComponent,
		TabComponent,
		...MaterialModules,
	],
	imports: [
		CommonModule,
		FormsModule,
		NgChartsModule,
		NgxMaskDirective,
		NgxMaskPipe,
		NgxSkeletonLoaderModule,
		ReactiveFormsModule,
		RouterModule,
		...MaterialModules,
	],
	providers: [
		provideNgxMask(),
		{ provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 5000 } },
	],
})
export class SharedModule {}
